import { useState, useEffect } from "react";
import { FaBars, FaBell, FaUser, FaSignOutAlt } from "react-icons/fa";
import { useAuth } from "../context/AuthProvider";
import "../css/Header.css";

const Header = ({ toggleSidebar }) => {
  const { logout } = useAuth();
  const [isMobile, setIsMobile] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleOutsideClick = (e) => {
    if (showProfileMenu) {
      setShowProfileMenu(false);
    }
  };

  useEffect(() => {
    if (showProfileMenu) {
      document.addEventListener('click', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [showProfileMenu]);

  const handleLogout = (e) => {
    e.preventDefault();
    logout();
  };

  return (
    <div className="header">
      {isMobile && (
        <button className="mobile-menu-btn" onClick={toggleSidebar}>
          <FaBars />
        </button>
      )}
      
      <div className="header-title">
        <h2>College Panel</h2>
      </div>
      
      <div className="header-right">
        {/* <div className="header-notification">
          <FaBell />
          <span className="notification-badge">3</span>
        </div> */}
        
        <div className="header-profile">
          <div 
            className="profile-avatar" 
            onClick={(e) => {
              e.stopPropagation();
              setShowProfileMenu(!showProfileMenu);
            }}
          >
            <FaUser />
          </div>
          
          {showProfileMenu && (
            <div className="profile-dropdown">
              <div className="profile-header">
                <div className="profile-name">Admin User</div>
                <div className="profile-email">admin@college.edu</div>
              </div>
              <ul className="profile-menu">
                <li><a href="/profile"><FaUser /> My Profile</a></li>
                <li><a href="/settings">Settings</a></li>
                <li className="divider"></li>
                <li><a href="#" onClick={handleLogout} className="logout-link"><FaSignOutAlt /> Logout</a></li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;